import { CALL_API, REQUEST_GET, REQUEST_POST } from '../middleware/api'
import {
  BOX_TRANSCRIPT_PRODUCT,
  BOX_TRANSCRIPT_PRODUCT_COLLECTION
} from '../schemas/index'
import { ERROR, SUCCESS } from '../components/AlertListItem'

export const GENERATE_WORK_FOLDER_REQUEST = 'GENERATE_WORK_FOLDER_REQUEST'
export const GENERATE_WORK_FOLDER_SUCCESS = 'GENERATE_WORK_FOLDER_SUCCESS'
export const GENERATE_WORK_FOLDER_FAILURE = 'GENERATE_WORK_FOLDER_FAILURE'
export const BOX_TRANSCRIPT_PRODUCTS_REQUEST = 'BOX_TRANSCRIPT_PRODUCTS_REQUEST'
export const BOX_TRANSCRIPT_PRODUCTS_SUCCESS = 'BOX_TRANSCRIPT_PRODUCTS_SUCCESS'
export const BOX_TRANSCRIPT_PRODUCTS_FAILURE = 'BOX_TRANSCRIPT_PRODUCTS_FAILURE'

export function fetchBoxTranscriptProducts() {
  return {
    [CALL_API]: {
      types: [
        BOX_TRANSCRIPT_PRODUCTS_REQUEST,
        BOX_TRANSCRIPT_PRODUCTS_SUCCESS,
        BOX_TRANSCRIPT_PRODUCTS_FAILURE
      ],
      endpoint: 'box_transcript_products.json',
      requestType: REQUEST_GET,
      schema: BOX_TRANSCRIPT_PRODUCT_COLLECTION
    }
  }
}

export function generateWorkFolder(boxTranscriptProduct) {
  return {
    idsGenerating: boxTranscriptProduct.id,
    [GENERATE_WORK_FOLDER_FAILURE]: {
      alert: {
        type: ERROR,
        message: 'Failed Generating Box Folder'
      }
    },
    [GENERATE_WORK_FOLDER_SUCCESS]: {
      entities: {
        boxTranscriptProducts: {
          [boxTranscriptProduct.id]: {
            name: boxTranscriptProduct.name,
            fileCount: boxTranscriptProduct.fileCount
          }
        }
      },
      alert: {
        type: SUCCESS,
        message: `Generating Box Folder for ${boxTranscriptProduct.name}`
      }
    },
    [CALL_API]: {
      types: [
        GENERATE_WORK_FOLDER_REQUEST,
        GENERATE_WORK_FOLDER_SUCCESS,
        GENERATE_WORK_FOLDER_FAILURE
      ],
      endpoint: `box_transcript_products/${boxTranscriptProduct.id}/generate_work_folder`,
      requestType: REQUEST_POST,
      schema: BOX_TRANSCRIPT_PRODUCT
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/boxTranscriptProductActions.js